module.exports = __webpack_public_path__ + "img/modernpereklad.2a00d86d.jpg";